
<template>
      <div class="appie-page-title-area appie-page-service-title-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="appie-page-title-item">
                        <span style="color: #8c8c8c">Trigger Your Palate & Order </span>
                        <h3 style="color: black" class="title">Join the First-Ever <br>Picture Menu Network </h3>
                        <div class="thumb">
                            <img src="assets/images/fun-fact-thumb.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>